import React, { Component } from 'react';
import axios from 'axios';
import { Form, Button, FormGroup, Col, Modal } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table-2';
import CaseStatus from '../components/retrieveQuotationComponent/caseStatus/CaseStatus';
import Product from '../components/retrieveQuotationComponent/product/Product';
import VehicleRegNo from '../components/retrieveQuotationComponent/vehicleRegNo/VehicleRegNo';
import AgentCodeName from '../components/agentCodeName/AgentCodeName';
import QuotationNo from '../components/retrieveQuotationComponent/quotationNo/QuotationNo';
import InsuredName from '../components/retrieveQuotationComponent/insuredName/InsuredName';
import QuotationDate from '../components/retrieveQuotationComponent/quotationDate/QuotationDate';
import ExpiredQuotation from '../components/retrieveQuotationComponent/expiredQuotation/ExpiredQuotation';
import { momentToISOString, momentSetHKTimezoneWithFormat } from '../../utils/dateUtils'
import config from '../../config/config';
import ProgressBar from '../components/progressBar/ProgressBar';

const appUrlPath = `/${config.appUrlPath}`;

function getInitState() {
  const role = localStorage.getItem('role');
  const agentCode = role === 'agent' ? localStorage.getItem('agentCode') : '';
  const agentName = role === 'agent' ? localStorage.getItem('displayName') : '';
  return {
    redirect: false,
    isLoading: false,
    isLoadingPDF: false,
    caseStatus: '',
    message: '',
    showModal: false,
    role,
    quotationDateFrom: null,
    quotationDateTo: null,
    agentCode,
    agentName,
    vehicleRegNo: '',
    quotationNo: '',
    insuredName: '',
    product: '',
    searchResult: [],
    totalDataSize: 0,
    expiredQuotation: false
  }
}

export class RetrieveQuotation extends Component {

  constructor(props) {
    super(props);
    this.state = getInitState();

    this.handleChangeSearchCondition = this.handleChangeSearchCondition.bind(this)
    this.handleChangeQuotationDateFrom = this.handleChangeQuotationDateFrom.bind(this)
    this.handleChangeQuotationDateTo = this.handleChangeQuotationDateTo.bind(this)
    this.handleGetAgentName = this.handleGetAgentName.bind(this);
    this.handleChangeAgentCode = this.handleChangeAgentCode.bind(this);
    this.close = this.close.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.printFormatter = this.printFormatter.bind(this);
    this.handleChangePrintQuotation = this.handleChangePrintQuotation.bind(this)

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {},
      headers: { 'ACTION-LOG': 'Access Retrieve Quotation Page' }
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  componentWillMount() {

  }

  onPageChange(page, sizePerPage) {
    axios.get(`${appUrlPath}/getQuotation`, {
      params: {
        limit: sizePerPage,
        skip: ((page - 1) * sizePerPage),
        caseStatus: this.state.caseStatus,
        quotationDateFrom: this.state.quotationDateFrom,
        quotationDateTo: this.state.quotationDateTo,
        agentCode: this.state.agentCode,
        agentName: this.state.agentName,
        vehicleRegNo: this.state.vehicleRegNo,
        quotationNo: this.state.quotationNo,
        insuredName: this.state.insuredName,
        product: this.state.product,
        expiredQuotation: this.state.expiredQuotation
      }
    })
    .then((res) => {
      const searchResult = [];
      for (let i = 0; i < res.data.result.length; i++) {
        const data = res.data.result[i]
        const quotationDate = momentSetHKTimezoneWithFormat(data.requestInfo.quotationDate, 'DD/MM/YYYY');
        const searchResultObj = {
          product: data.type === 'pv' ? 'SmartDrive Private Car' : 'SmartDrive Commercial Vehicle',
          productType: data.type,
          quotationDate,
          quotationNo: data.requestInfo.quotationNo,
          agentCode: data.requestInfo.agentCode,
          creator: 'Not Ready',
          caseStatus: data.caseStatus
        }
        searchResult.push(searchResultObj)
      }

      this.setState({ searchResult, totalDataSize: res.data.resultCount })
    })
    .catch((error) => {
      this.setState({
        message: error.message,
        showModal: true
      });
    });
  }

  handleChangeSearchCondition(e) {
    const state = { ...this.state }
    if (e.target.id === 'product') {
      state.product = e.target.value
    } else if (e.target.id === 'caseStatus') {
      state.caseStatus = e.target.value
    } else if (e.target.id === 'vehicleRegNo') {
      state.vehicleRegNo = e.target.value
    } else if (e.target.id === 'quotationNo') {
      state.quotationNo = e.target.value
    } else if (e.target.id === 'insuredName') {
      state.insuredName = e.target.value
    } else if (e.target.name === 'expiredQuotation') {
      state.expiredQuotation = e.target.checked
    }
    this.setState(state)
  }

  handleClear() {
    this.setState(getInitState());
  }

  handleChangeQuotationDateFrom(e) {
    this.setState({ quotationDateFrom: e !== null ? momentToISOString(e) : null })
  }

  handleChangeQuotationDateTo(e) {
    this.setState({ quotationDateTo: e !== null ? momentToISOString(e) : null })
  }

  handleClick() {
    window.location.assign('/en/motorb2b/home');
  }

  close() {
    this.setState({ showModal: false });
  }

  handleChangeAgentCode(e) {
    const agentCode = e.target.value;
    this.setState({
      agentCode
    });
  }

  handleGetAgentName(e) {
    const agentCode = e.target.value;
    axios.post(`${appUrlPath}/getAgentName`, {
      agentCode
    })
    .then((res) => {
      this.setState({
        agentName: res.data.agentName
      })
    });
  }

  handleChangePrintQuotation(searchObj) {
    this.setState({ isLoadingPDF: true })
    if (searchObj.productType === 'pv') {
      axios.post(`${appUrlPath}/quotationPVPrint`, searchObj, { responseType: 'arraybuffer' })
      .then((res) => {
        const file = new Blob([res.data], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE
          window.navigator.msSaveOrOpenBlob(file, `PV_Quotation_${searchObj.quotationNo}.pdf`);
        } else {
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
        }
        this.setState({ isLoadingPDF: false })
      }).catch((error) => {
        this.setState({
          message: error.message,
          showModal: true,
          isLoadingPDF: false
        });
      });
    } else if (searchObj.productType === 'cv') {
      axios.post(`${appUrlPath}/quotationCVPrint`, searchObj, { responseType: 'arraybuffer' })
      .then((res) => {
        const file = new Blob([res.data], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE
          window.navigator.msSaveOrOpenBlob(file, `CV_Quotation_${searchObj.quotationNo}.pdf`);
        } else {
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
        }
        this.setState({ isLoadingPDF: false })
      }).catch((error) => {
        this.setState({
          message: error.message,
          showModal: true,
          isLoadingPDF: false
        });
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.product === '' && this.state.quotationNo === '') {
      this.setState({
        message: 'Please fill the product or quotation no.',
        showModal: true
      });
      return
    }
    this.setState({ isLoading: true });
    axios.get(`${appUrlPath}/getQuotation`, {
      params: {
        limit: 10,
        skip: 0,
        caseStatus: this.state.caseStatus,
        quotationDateFrom: this.state.quotationDateFrom,
        quotationDateTo: this.state.quotationDateTo,
        agentCode: this.state.agentCode,
        agentName: this.state.agentName,
        vehicleRegNo: this.state.vehicleRegNo,
        quotationNo: this.state.quotationNo,
        insuredName: this.state.insuredName,
        product: this.state.product,
        expiredQuotation: this.state.expiredQuotation
      }
    })
    .then((res) => {
      const searchResult = [];
      for (let i = 0; i < res.data.result.length; i++) {
        const data = res.data.result[i]
        const quotationDate = momentSetHKTimezoneWithFormat(data.requestInfo.quotationDate, 'DD/MM/YYYY');

        const searchResultObj = {
          product: data.type === 'pv' ? 'SmartDrive Private Car' : 'SmartDrive Commercial Vehicle',
          productType: data.type,
          quotationDate,
          quotationNo: data.requestInfo.quotationNo,
          agentCode: data.requestInfo.agentCode,
          creator: data.requestInfo.agentName,
          caseStatus: data.caseStatus
        }
        searchResult.push(searchResultObj)
      }

      this.setState({ searchResult, totalDataSize: res.data.resultCount, isLoading: false })
    })
    .catch((error) => {
      this.setState({
        message: error.message,
        showModal: true,
        isLoading: false
      });
    });
  }

  colFormatter(cell, row) {
    let form = '/pvform'
    if (row.productType === 'pv') {
      form = '/pvform'
    } else if (row.productType === 'cv') {
      form = '/cvform'
    }
    const link = `/en${appUrlPath}${form}?quotationNo=${cell}`
    return (<a href={link}>{cell}</a>)
  }

  printFormatter(cell, row) {
    const searchObj = { 'productType': row.productType, 'quotationNo': row.quotationNo }
    return (<button type="button" className="btn btn-axa btn-xs" onClick={() => this.handleChangePrintQuotation(searchObj)}>REPRINT</button>)
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ color: 'blue' }}>
        From { start } to { to }, totals is { total }
      </p>
    );
  }

  render() {
    const options = {
      sizePerPageList: [], // you can change the dropdown list for size per page
      sizePerPage: 10,  // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 3,  // the pagination bar size.
      prePage: 'Prev', // Previous page button text
      nextPage: 'Next', // Next page button text
      firstPage: 'First', // First page button text
      lastPage: 'Last', // Last page button text
      prePageTitle: 'Go to previous', // Previous page button title
      nextPageTitle: 'Go to next', // Next page button title
      firstPageTitle: 'Go to first', // First page button title
      lastPageTitle: 'Go to Last', // Last page button title
      paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
      paginationPosition: 'bottom',  // default is bottom, top and both is all available
      onPageChange: this.onPageChange,
      page: this.state.page,
      onSizePerPageList: this.onSizePerPageList
    };

    if (this.state.isLoadingPDF || this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    return (
      <div>
      {this.state.showModal ?
      <Modal.Dialog>
        <Modal.Header>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.message}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.close}>OK</Button>
        </Modal.Footer>
      </Modal.Dialog> : null}
       <h2 className="ebaoUtil__HeaderTwo">Retrieve Quotation</h2>
       <h3 className="ebaoUtil__HeaderThree">Search Condition (Quotation No. or Product Code required)</h3>
       <Form onSubmit={this.handleSubmit}>
          <div className="ebaoUtil__Form-100">
            <FormGroup controlId="caseStatus">
              <Col sm={6}>
                <CaseStatus
                  caseStatus={this.state.caseStatus}
                  handleChangeCaseStatus={this.handleChangeSearchCondition}
                />
              </Col>
              <Col sm={6}>
                <AgentCodeName
                  agentCode={this.state.agentCode}
                  agentName={this.state.agentName}
                  handleGetAgentName={this.handleGetAgentName}
                  handleChangeAgentCode={this.handleChangeAgentCode}
                  systemRole={this.state.role}
                  required={false}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="">
              <Col sm={6}>
                <Product
                  product={this.state.product}
                  handleChangeProduct={this.handleChangeSearchCondition}
                />
              </Col>
              <Col sm={6}>
                <VehicleRegNo
                  vehicleRegNo={this.state.vehicleRegNo}
                  handleChangeVehicleRegNo={this.handleChangeSearchCondition}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="">
              <Col sm={6}>
                <QuotationNo
                  quotationNo={this.state.quotationNo}
                  handleChangeQuotationNo={this.handleChangeSearchCondition}
                />
              </Col>
              <Col sm={6}>
                <InsuredName
                  insuredName={this.state.insuredName}
                  handleChangeInsuredName={this.handleChangeSearchCondition}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="">
              <Col sm={12}>
                <QuotationDate
                  startDateLabel="Quotation Date From"
                  endDateLabel="Quotation Date To"
                  startDate={this.state.quotationDateFrom}
                  endDate={this.state.quotationDateTo}
                  handleChangeStartDate={this.handleChangeQuotationDateFrom}
                  handleChangeEndDate={this.handleChangeQuotationDateTo}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="">
              <Col sm={6}>
                <ExpiredQuotation
                  expiredQuotation={this.state.expiredQuotation}
                  handleChangeExpiredQuotation={this.handleChangeSearchCondition}
                />
              </Col>
              <Col sm={6} />
            </FormGroup>
            <FormGroup controlId="">
              <Col sm={6} />
              <Col sm={6}>
                <div className="ebaoUtil__Row">
                  <div className="ebaoUtil__ButtonGroup">
                    <button type="submit" className="btn btn-axa">Search</button>{' '}
                    <button type="button" className="btn btn-axa" onClick={this.handleClear}>Clear</button>
                  </div>
                </div>
              </Col>
            </FormGroup>
          </div>
       </Form>
       <br /><br /><br /><br />
       <BootstrapTable
          data={this.state.searchResult}
          pagination
          options={options}
          remote
          fetchInfo={{ dataTotalSize: this.state.totalDataSize }}
       >
          <TableHeaderColumn dataField="product">Product</TableHeaderColumn>
          <TableHeaderColumn dataField="quotationDate">Quotation Date</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.colFormatter} dataField="quotationNo" isKey>Quotation No</TableHeaderColumn>
          <TableHeaderColumn dataField="agentCode">Agent Code</TableHeaderColumn>
          <TableHeaderColumn dataField="creator">Creator</TableHeaderColumn>
          <TableHeaderColumn dataField="caseStatus">Case Status</TableHeaderColumn>
          <TableHeaderColumn editable={false} dataFormat={this.printFormatter} dataField="printQuotation">Print Quot</TableHeaderColumn>

        </BootstrapTable>

    </div>
    )
  }
}

export default RetrieveQuotation;


// WEBPACK FOOTER //
// ./src/app/pages/RetrieveQuotation.js